import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken, putAPIwithToken, deleteAPIwithToken } from '../utils/fetchApi';

// ==========================================
// 1. ZONES API (GET, POST, PUT, DELETE)
// ==========================================
export const getZonesAPI = async () => {
  return await getAPIwithToken(ENDPOINTS.GET_ZONES);
};

export const createZoneAPI = async (payload: { name: string; sapCode?: string | null }) => {
  return await postAPIwithToken(ENDPOINTS.CREATE_ZONE, payload);
};

export const updateZoneAPI = async (id: number | string, payload: { name: string; status?: number; sapCode?: string | null }) => {
  return await putAPIwithToken(ENDPOINTS.UPDATE_ZONE(id), { id, ...payload });
};

export const deleteZoneAPI = async (id: number | string) => {
  return await deleteAPIwithToken(ENDPOINTS.DELETE_ZONE(id), { id });
};

// ==========================================
// 2. CITIES API (GET, POST, PUT, DELETE)
// ==========================================
export const getCitiesAPI = async (zoneId?: number) => {
  const url = zoneId ? `${ENDPOINTS.GET_CITIES}?zoneId=${zoneId}` : ENDPOINTS.GET_CITIES;
  return await getAPIwithToken(url);
};

export const createCityAPI = async (payload: { name: string; territoryId?: number; sapCode?: string | null }) => {
  return await postAPIwithToken(ENDPOINTS.CREATE_CITY, payload);
};

export const updateCityAPI = async (id: number | string, payload: { name: string; territoryId?: number; sapCode?: string | null }) => {
  return await putAPIwithToken(ENDPOINTS.UPDATE_CITY(id), { id, ...payload });
};

export const deleteCityAPI = async (id: number | string) => {
  return await deleteAPIwithToken(ENDPOINTS.DELETE_CITY(id), { id });
};

// ==========================================
// 3. DEPOS API (GET, POST, PUT, DELETE)
// ==========================================
export const getDeposAPI = async () => {
  return await getAPIwithToken(ENDPOINTS.GET_DEPOS);
};

export const createDepoAPI = async (payload: { zoneId?: number; cityId?: number; name: string; sapCode?: string | null; sapName?: string | null }) => {
  return await postAPIwithToken(ENDPOINTS.CREATE_DEPO, payload);
};

export const updateDepoAPI = async (id: number | string, payload: { name?: string; sapCode?: string | null; sapName?: string | null; zoneId?: number; cityId?: number }) => {
  return await putAPIwithToken(ENDPOINTS.UPDATE_DEPO(id), { id, ...payload });
};

export const deleteDepoAPI = async (id: number | string) => {
  return await deleteAPIwithToken(ENDPOINTS.DELETE_DEPO(id), { id });
};

// ==========================================
// 4. ROUTES API (GET, POST, PUT, DELETE)
// ==========================================
export const getRoutesAPI = async () => {
  return await getAPIwithToken(ENDPOINTS.GET_ROUTES);
};

export const createRouteAPI = async (payload: { depoId?: number; name: string; sapCode?: string | null }) => {
  return await postAPIwithToken(ENDPOINTS.CREATE_ROUTE, payload);
};

export const updateRouteAPI = async (id: number | string, payload: { name?: string; sapCode?: string | null; depoId?: number }) => {
  return await putAPIwithToken(ENDPOINTS.UPDATE_ROUTE(id), { id, ...payload });
};

export const deleteRouteAPI = async (id: number | string) => {
  return await deleteAPIwithToken(ENDPOINTS.DELETE_ROUTE(id), { id });
};

// ==========================================
// 5. TERRITORIES API (GET, GET_BY_ID, POST, PUT, DELETE)
// ==========================================
export const getTerritoriesAPI = async () => {
  return await getAPIwithToken(ENDPOINTS.GET_TERRITORIES);
};

export const getTerritoryByIdAPI = async (id: number | string) => {
  return await getAPIwithToken(ENDPOINTS.GET_TERRITORY_BY_ID(id));
};

export const createTerritoryAPI = async (payload: { name: string; zoneId?: number; sapCode?: string | null }) => {
  return await postAPIwithToken(ENDPOINTS.CREATE_TERRITORY, payload);
};

export const updateTerritoryAPI = async (id: number | string, payload: { name: string; zoneId?: number; status?: number | string; sapCode?: string | null }) => {
  return await putAPIwithToken(ENDPOINTS.UPDATE_TERRITORY(id), { id, ...payload });
};

export const deleteTerritoryAPI = async (id: number | string) => {
  return await deleteAPIwithToken(ENDPOINTS.DELETE_TERRITORY(id), { id });
};
